// extracted by mini-css-extract-plugin
module.exports = {"form":"style_form__2V251","formTitle":"style_formTitle__fgVDK","errMsg":"style_errMsg__3sTcp"};